<form [formGroup]="formGroup">
  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <h3 class="mr-3">{{ pageTitle }}</h3>
    <p-select
      [options]="profiles"
      optionLabel="name"
      optionValue="conMonProfileId"
      [(ngModel)]="conMonProfileId"
      (onChange)="onProfileChanged($event)"
      [ngModelOptions]="{standalone: true}"
    >
    </p-select>
    <div class="flex align-items-center">
      <p-button
        [text]="true"
        pTooltip="Create New"
        icon="pi pi-plus"
        (click)="createProfile()"
      ></p-button>
      <p-button
        *ngIf="profile"
        [text]="true"
        icon="pi pi-trash"
        severity="danger"
        mwlConfirmationPopover
        [title]="'Delete Selected Package'"
        [popoverMessage]="
              'You are going to delete selected Package. Are you sure?'
            "
        [appendToBody]="true"
        [confirmText]="'Yes'"
        [cancelText]="'No'"
        placement="bottom"
        (confirm)="removeProfile()"
      ></p-button>
    </div>
    <mat-form-field style="width: 50%">
      <mat-label>Name</mat-label>
      <input matInput name="name" formControlName="name" required />
    </mat-form-field>
    <p-button
      [text]="true"
      icon="pi pi-save"
      (click)="onDone()"
      *ngIf="profile"
    ></p-button>
    <p-button
      [text]="true"
      icon="pi pi-download"
      (click)="download()"
      *ngIf="profile"
    ></p-button>
    <p-button
      [text]="true"
      icon="pi pi-copy"
      (click)="copy()"
      *ngIf="profile"
    ></p-button>
  </div>
  <div style="display: flex; flex-direction: column;" id="sapProfileLayoutDiv" *ngIf="profile">
    <div>
      <mat-horizontal-stepper [linear]="false">
        <mat-step label="General Information" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Prepared By</mat-label>
              <input matInput formControlName="preparedByName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Notes</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="notes">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Attestation Letter</mat-label>
              <textarea matInput formControlName="attestationLetter" style="min-height: 400px;"></textarea>
            </mat-form-field>
          </div>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
            @if (this.formGroup.value.signedName) {
              Signed by {{this.formGroup.value.signedName}} on {{this.formGroup.value.signedDate | date : 'shortDate'}}
            }
            <i class="pi pi-credit-card cursor-pointer" (click)="sign()"></i>
          </div>
        </mat-step>
        <mat-step label="Export" [stepControl]="{invalid: false}">

          <div class="row">
            <div class="col-4">
              <mat-checkbox formControlName="includeDbScans">Database Scans
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includeHighRiskVulnerabilities">High Risk Vulnerabilities
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includeEvidence">Evidence
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includeAppScans">App Scans
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includePoamReports">POAM Reports
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includeDocumentation">Documentation
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includeContainerScans">Container Scans
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includePolicies">Policies
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includeInfrastructureScans">Infrastructure Scans
              </mat-checkbox>
            </div>
            <div class="col-4">
              <mat-checkbox formControlName="includeIncidents">Incidents
              </mat-checkbox>
            </div>
          </div>

          <div class="row">
            <div>
              <mat-form-field>
                <mat-label>Start Date</mat-label>
                <input matInput formControlName="startDate" [matDatepicker]="pickerStartDate"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerStartDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div style="flex:1%"></div>
            <div>
              <mat-form-field>
                <mat-label>End Date</mat-label>
                <input matInput formControlName="endDate" [matDatepicker]="pickerEndDate"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerEndDate></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Project" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Project</mat-label>
              <mat-select formControlName="projectId" (selectionChange)="projectChanged($event)">
                <mat-option [value]="project.projectId" *ngFor="let project of projects">{{ project.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="projectItProfiles">
            <mat-form-field>
              <mat-label>IT Profile</mat-label>
              <mat-select formControlName="clientItProfileId">
                <mat-option [value]="itProfile.clientITProfileId"
                            *ngFor="let itProfile of projectItProfiles">{{ itProfile.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <p-table [value]="projectControlItems"
                   dataKey="controlItem.category"
                   selectionMode="multiple"
                   [(selection)]="selectedProjectControlItems">

            <ng-template pTemplate="header">
              <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                <th style="width: 5em;">
                  <p-checkbox (onChange)="selectAllProjectControlItems($event)" [value]="true"></p-checkbox>
                </th>
                <th>Category</th>
                <th>Control ID</th>
                <th>Description</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                         let-columns="columns">
              <tr class="ui-widget-header"
                  *ngIf="rowGroupMetadata[item.controlItem.category].index === rowIndex">
                <td colspan="4">
                  <a href="#" [pRowToggler]="item">
                    <i
                      [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    <span>{{ item.controlItem.complianceArea.name }} - {{ item.controlItem.category }}</span>
                  </a>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>
                  <p-checkbox [(ngModel)]="item.checked" [ngModelOptions]="{standalone: true}" binary="true"
                              [readonly]="item.controlItem?.parentControlItemId"></p-checkbox>
                </td>
                <td (click)="item.checked = !item.checked">{{ item.controlItem.category }}</td>
                <td (click)="item.checked = !item.checked">{{ item.controlItem.complianceAreaControlId }}</td>
                <td (click)="item.checked = !item.checked">{{ item.controlItem.description }}</td>
              </tr>
            </ng-template>
          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>

        </mat-step>
        <mat-step label="Infrastructure Scan Results" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Infrastructure Scanner Name</mat-label>
              <input matInput formControlName="infrastructureScannerName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Infrastructure Scanner Vendor</mat-label>
              <input matInput formControlName="infrastructureScannerVendor" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Infrastructure Scanner Version</mat-label>
              <input matInput formControlName="infrastructureScannerVersion" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Infrastructure Percentage Scanned</mat-label>
              <input matInput formControlName="infrastructurePercentageScanned" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>not recommends significant change/significant change(s)</mat-label>
              <mat-select formControlName="isInfrastructureDiscrepancy">
                <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                  inventory
                </mat-option>
                <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                  been recorded in the RET
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>The discrepancies were due to</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="infrastructureDiscrepancyReasons">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Infrastructure Detect Date</mat-label>
              <input matInput formControlName="infrastructureScanDate" [matDatepicker]="pickerInfrastructureScanDate"
                     required>
              <mat-datepicker-toggle matSuffix [for]="pickerInfrastructureScanDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerInfrastructureScanDate></mat-datepicker>
            </mat-form-field>
          </div>

          <p-table [value]="zipFiles['Infrastructure']"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapZipFileId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Infrastructure Scans: Raw Scan File Index</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showZipFileDialog({title : '', fileName : '', kind: 0}, 'Infrastructure')"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.title }}</td>
                <td>{{ item.fileName }}</td>
                <td>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showZipFileDialog(item, 'Infrastructure')"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteZipFile(item, 'Infrastructure')"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Database Scan Results" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Database Scanner Name</mat-label>
              <input matInput formControlName="dbScannerName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Database Scanner Vendor</mat-label>
              <input matInput formControlName="dbScannerVendor" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Database Scanner Version</mat-label>
              <input matInput formControlName="dbScannerVersion" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Database Percentage Scanned</mat-label>
              <input matInput formControlName="dbPercentageScanned" />
            </mat-form-field>
          </div>
          <div>
            <mat-checkbox formControlName="isDbScan">For the remaining inventory, the performed a manual review
            </mat-checkbox>
          </div>
          <div>
            <mat-form-field>
              <mat-label>not recommends significant change/significant change(s)</mat-label>
              <mat-select formControlName="isDbDiscrepancy">
                <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                  inventory
                </mat-option>
                <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                  been recorded in the RET
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>The discrepancies were due to</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="dbDiscrepancyReasons">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Database Detect Date</mat-label>
              <input matInput formControlName="dbScanDate" [matDatepicker]="pickerDatabaseScanDate" required>
              <mat-datepicker-toggle matSuffix [for]="pickerDatabaseScanDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerDatabaseScanDate></mat-datepicker>
            </mat-form-field>
          </div>

          <p-table [value]="zipFiles['Db']"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapZipFileId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Database Scans: Raw Scan File Index</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showZipFileDialog({title : '', fileName : '', kind: 1}, 'Db')"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.title }}</td>
                <td>{{ item.fileName }}</td>
                <td>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showZipFileDialog(item, 'Db')"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteZipFile(item, 'Db')"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Web Scan Results" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Web Scanner Name</mat-label>
              <input matInput formControlName="webScannerName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Web Scanner Vendor</mat-label>
              <input matInput formControlName="webScannerVendor" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Web Scanner Version</mat-label>
              <input matInput formControlName="webScannerVersion" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Web App Percentage Scanned</mat-label>
              <input matInput formControlName="webPercentageAppScanned" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Web API Percentage Scanned</mat-label>
              <input matInput formControlName="webPercentageApiScanned" />
            </mat-form-field>
          </div>
          <div>
            <mat-checkbox formControlName="isWebScan">For the remaining inventory, the performed a manual review
            </mat-checkbox>
          </div>
          <div>
            <mat-form-field>
              <mat-label>not recommends significant change/significant change(s)</mat-label>
              <mat-select formControlName="isWebDiscrepancy">
                <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                  inventory
                </mat-option>
                <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                  been recorded in the RET
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>The discrepancies were due to</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="webDiscrepancyReasons">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Web Detect Date</mat-label>
              <input matInput formControlName="webScanDate" [matDatepicker]="pickerWebScanDate" required>
              <mat-datepicker-toggle matSuffix [for]="pickerWebScanDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerWebScanDate></mat-datepicker>
            </mat-form-field>
          </div>
          <p-table [value]="zipFiles['Web']"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapZipFileId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Web Application Scans: Raw Scan File Index</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showZipFileDialog({title : '', fileName : '', kind: 2}, 'Web')"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.title }}</td>
                <td>{{ item.fileName }}</td>
                <td>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showZipFileDialog(item, 'Web')"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteZipFile(item, 'Web')"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Benchmark Scan Results" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Benchmark Scanner Name</mat-label>
              <input matInput formControlName="benchmarkScannerName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Benchmark Scanner Vendor</mat-label>
              <input matInput formControlName="benchmarkScannerVendor" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Benchmark Scanner Version</mat-label>
              <input matInput formControlName="benchmarkScannerVersion" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Benchmark App Percentage Scanned</mat-label>
              <input matInput formControlName="benchmarkPercentageAppScanned" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Benchmark API Percentage Scanned</mat-label>
              <input matInput formControlName="benchmarkPercentageApiScanned" />
            </mat-form-field>
          </div>
          <div>
            <mat-checkbox formControlName="isBenchmarkScan">For the remaining inventory, the performed a manual review
            </mat-checkbox>
          </div>
          <div>
            <mat-form-field>
              <mat-label>not recommends significant change/significant change(s)</mat-label>
              <mat-select formControlName="isBenchmarkDiscrepancy">
                <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                  inventory
                </mat-option>
                <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                  been recorded in the RET
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>The discrepancies were due to</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="benchmarkDiscrepancyReasons">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Benchmark Detect Date</mat-label>
              <input matInput formControlName="benchmarkScanDate" [matDatepicker]="pickerBenchmarkScanDate" required>
              <mat-datepicker-toggle matSuffix [for]="pickerBenchmarkScanDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerBenchmarkScanDate></mat-datepicker>
            </mat-form-field>
          </div>
          <p-table [value]="zipFiles['Benchmark']"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapZipFileId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Benchmark Application Scans: Raw Scan File Index</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showZipFileDialog({title : '', fileName : '', kind: 5}, 'Benchmark')"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.title }}</td>
                <td>{{ item.fileName }}</td>
                <td>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showZipFileDialog(item, 'Benchmark')"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteZipFile(item, 'Benchmark')"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Containers" [stepControl]="{invalid: false}">

          <div>
            <mat-form-field>
              <mat-label>Container Scanner Name</mat-label>
              <input matInput formControlName="containerScannerName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Container Scanner Vendor</mat-label>
              <input matInput formControlName="containerScannerVendor" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Container Scanner Version</mat-label>
              <input matInput formControlName="containerScannerVersion" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Container Percentage Scanned</mat-label>
              <input matInput formControlName="containerPercentageScanned" />
            </mat-form-field>
          </div>
          <div>
            <mat-checkbox formControlName="isContainerScan">For the remaining inventory, the performed a manual
              review
            </mat-checkbox>
          </div>
          <div>
            <mat-form-field>
              <mat-label>not recommends significant change/significant change(s)</mat-label>
              <mat-select formControlName="isContainerDiscrepancy">
                <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                  inventory
                </mat-option>
                <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                  been recorded in the RET
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>The discrepancies were due to</mat-label>
              <textarea matInput
                        type="text"
                        formControlName="containerDiscrepancyReasons">
                            </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Container Detect Date</mat-label>
              <input matInput formControlName="containerScanDate" [matDatepicker]="pickerContainerScanDate" required>
              <mat-datepicker-toggle matSuffix [for]="pickerContainerScanDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerContainerScanDate></mat-datepicker>
            </mat-form-field>
          </div>

          <p-table [value]="zipFiles['Container']"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapZipFileId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Container Scans: Raw Scan File Index</div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showZipFileDialog({title : '', fileName : '', kind: 3}, 'Container')"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.title }}</td>
                <td>{{ item.fileName }}</td>
                <td>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showZipFileDialog(item, 'Container')"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteZipFile(item, 'Container')"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
        <mat-step label="Other" [stepControl]="{invalid: false}">
          <div>
            <mat-form-field>
              <mat-label>Other Detect Date</mat-label>
              <input matInput formControlName="otherScanDate" [matDatepicker]="pickerOtherScanDate" required>
              <mat-datepicker-toggle matSuffix [for]="pickerOtherScanDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerOtherScanDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Penetration Test AuxiliaryDocument</mat-label>
              <input matInput formControlName="penTestLocation" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Penetration Test Date</mat-label>
              <input matInput formControlName="penTestDate" [matDatepicker]="pickerPenTestDate" required>
              <mat-datepicker-toggle matSuffix [for]="pickerPenTestDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerPenTestDate></mat-datepicker>
            </mat-form-field>
          </div>

          <p-table [value]="zipFiles['Other']"
                   [rows]="10"
                   selectionMode="single"
                   [paginator]="true"
                   [style]="{'margin-top':'10px'}"
                   sortField="sapZipFileId">

            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div style="float: left;">Other Automated and Miscellaneous Tool Results: List of Raw Scan
                  Result Files
                </div>
                <button type="button"
                        pButton
                        icon="pi pi-plus"
                        (click)="showZipFileDialog({title : '', fileName : '', kind: 4}, 'Other')"
                        label="Add"
                        class="risksponge-button"
                        style="float:right">
                </button>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                    [ngStyle]="{ width: col.width || 'auto' }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th [ngStyle]="{width:'7em'}"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
              <tr>
                <td>{{ item.title }}</td>
                <td>{{ item.fileName }}</td>
                <td>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="showZipFileDialog(item, 'Other')"
                          icon="pi pi-pencil">
                  </button>

                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteZipFile(item, 'Other')"
                          icon="pi pi-trash">
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <div>
            <button mat-raised-button
                    matStepperPrevious
                    type="button">
              Back
            </button>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button
                    (click)="onDone()">
              Save
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</form>
<p-dialog header="File"
          [(visible)]="zipFileDialogVisible"

          showEffect="fade"
          [formGroup]="zipFileFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Title</mat-label>
    <input matInput
           name="role"
           required
           formControlName="title">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>File Name (Include Extension)</mat-label>
    <input matInput
           name="role"
           required
           [readonly]="editedZipFile?.conMonFileAttachmentId"
           formControlName="fileName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <label for="fileBlob2" class="btn" matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
    <i class="pi pi-plus"></i>
    <input id="fileBlob2"
           type="file"
           accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
           (change)="AddZipFile($event)"
           name="addAttachedFile2"
           style="display: none;" />
  </label>

  <a
    [href]="api + '/api/attachments/file?name=' + encodeURIComponent(editedZipFile?.internalName) + '&path=Account/ConMon Profiles' + '&token=' + token"
    *ngIf="editedZipFile?.conMonFileAttachmentId">{{ editedZipFile.fileName }}</a>


  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveZipFile()">
        Save
      </button>


      <button mat-raised-button
              (click)="zipFileDialogVisible = false; editedZipFile = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>
